import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
// import OrderStatusChip from "./OrderStatusChip";
// import OrderActions from "./OrderActions";
import {
  FooterBox,
  StyledPaper,
  StyledTableCellHead,
  StyledTableHead,
  ellipsisSx,
} from "./style";
import ProductActions from "./ProductActions";
// import { StyledButtonSend } from "../../chat-box/style";
// import { MdChevronRight } from "react-icons/md";

export default function ProductTable({
  columns = [],
  rows = [],
  selectedTab = 0,
  tabLabels = [],
  recordList,
  intakeScope = "admin",
}) {
  return (
    <StyledPaper tabLabel={tabLabels[selectedTab]}>
      <TableContainer sx={{ overflowX: "auto" }}>
        <Table sx={{ minWidth: 900 }}>
          <StyledTableHead tabLabel={tabLabels[selectedTab]}>
            <TableRow>
              {columns.map((col, i) => (
                <StyledTableCellHead
                  key={`${col.key}-${i}`}
                  sx={{ whiteSpace: "nowrap", minWidth: col.minWidth || 90 }}
                >
                  {col.label}
                </StyledTableCellHead>
              ))}
            </TableRow>
          </StyledTableHead>
          <TableBody>
            {rows.length > 0 ? (
              rows.map((row, idx) => (
                <TableRow key={row.id || `row-${idx}`}>
                  {columns.map((col, colIdx) => {
                    if (col.key === "actions") {
                      return (
                        <TableCell key={`actions-${idx}`} sx={{ whiteSpace: "nowrap" }}>
                          <ProductActions
                            row={row}
                            recordList={recordList}
                            intakeScope={intakeScope}
                          />
                        </TableCell>
                      );
                    }
                    if (col.key === "product_images") {
                      return (
                        <TableCell key={`images-${idx}`} sx={{ whiteSpace: "nowrap" }}>
                          {row[col.key]}
                        </TableCell>
                      );
                    }
                    if (col.key === "status" || col.key === "isShopperAssigned" || col.key === "payment_status") {
                      return (
                        <TableCell key={`${col.key}-${idx}`} sx={{ whiteSpace: "nowrap" }}>
                          {row[col.key] !== undefined && row[col.key] !== null && row[col.key] !== ""
                            ? row[col.key]
                            : "-"}
                        </TableCell>
                      );
                    }
                    return (
                      <TableCell key={`${colIdx}-${idx}`} sx={ellipsisSx}>
                        {row[col.key] !== undefined && row[col.key] !== null && row[col.key] !== ""
                          ? row[col.key]
                          : "-"}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={columns.length} align="center">
                  <Typography>No records found</Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <FooterBox>
        <Typography variant="body2">Showing {rows.length} results</Typography>
        {/* <StyledButtonSend
          endIcon={<MdChevronRight />}
          size="small"
          variant="outlined"
          color={
            tabLabels[selectedTab] === "Pickups" ||
            tabLabels[selectedTab] === "Shipments"
              ? "warning"
              : "primary"
          }
        >
          VIEW ALL
        </StyledButtonSend> */}
      </FooterBox>
    </StyledPaper>
  );
}
